import { render, staticRenderFns } from "./FlexButton.vue?vue&type=template&id=f4bd9678&"
import script from "./FlexButton.vue?vue&type=script&lang=js&"
export * from "./FlexButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports